<div class="w-100 h-100">
    <div class="d-flex justify-content-center">
        <div class="box pb-3">
            <div class="card-box bg-blue" :class="{'active': filterModel.requestStatus === 0}" @click="filter(0)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('employeeStatistics.allProcessingRequests')}} </label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{employeeStatisticsBoxModel.allCount}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-green" :class="{'active': filterModel.requestStatus === 2}" @click="filter(2)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('employeeStatistics.finalApprovedProcessingRequests')}} </label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{employeeStatisticsBoxModel.finalApprovedCount}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-deep-purple" :class="{'active': filterModel.requestStatus === 10}" @click="filter(10)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('employeeStatistics.approvedProcessingRequests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{employeeStatisticsBoxModel.approvedCount}}</h2>
                    </div>
                </div>
            </div>
        </div>
        <div class="box pb-3">
            <div class="card-box bg-red " :class="{'active': filterModel.requestStatus === 3}" @click="filter(3)">
                <div class="form-row justify-content-between align-items-center">
                    <div class="col-auto">
                        <label class="header">{{$t('employeeStatistics.rejectedProcessingRequests')}}</label>
                    </div>
                    <div class="col-auto pt-0">
                        <h2 class="number">{{employeeStatisticsBoxModel.rejctedCount}}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card">
        <div class="row col-md-12 pl-4 pr-4 ">
            <div class="container ">
                <div class="col-md-12 form-row justify-content align-items-center">
                    <div class="col-md-3">
                        <v-select v-model="viewBy"
                                  :items="viewByOption"
                                  item-text="name"
                                  item-value="id"
                                  solo attach>
                        </v-select>
                    </div>
                    <div class="col-md-3">
                        <v-select v-model="requestType"
                                  :items="requestOption"
                                 placeholder="Request Type"
                                  item-text="name"
                                  item-value="id"
                                  solo attach>
                        </v-select>
                    </div>
                    <div class="col-md-5">
                    </div>
                    <div class="col-md-1  col-auto fa-pull-right">
                        <button @click="apply()" class="btn btn-primary btn-action">
                            {{$t('shared.apply')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row align-content-center">
            <div class="container">
                <div class="col-md-12 align-content-center row pb-3">
                    <div class="col-md-7">
                        <div class="card-box">
                            <template>
                                <div style="max-height: 430px; overflow-y: auto; padding: 10px; border-radius: 8px; direction: rtl; ">
                                    <div id="bar_chart-div" style="width: 100%; position: relative; direction: rtl;">
                                        <canvas id="bar_charts"></canvas>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="col-md-5 card-box">
                        <template>
                            <canvas id="pie_charts"></canvas>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row row-table">
        <div class="col-md-12">
            <div class="card card_layout">
                <div class="card-header">
                    <div class="form-row justify-content-between align-items-center w-100">
                        <div class="col-auto">
                            <label class="card_header_text">
                                <i class="fas fa-sync-alt reload" @click="search()"></i>
                                {{$t('employeeStatistics.requests')}} ({{sendersCount}})
                            </label>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary btn-action" @click="exportToExcel()">{{$t('employeeStatistics.exportToExcel')}}</button>
                            <button @click="reset" class="btn btn-primary btn-action">{{$t('shared.reset')}}</button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.displayId"
                                       @keypress="search"
                                       :placeholder="$t('dashboardPage.displayId')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <input class="form-control border-right-0 border-left"
                                       type="text"
                                       v-model="filterModel.senderName"
                                       @keypress="search"
                                       :placeholder="$t('employeeStatistics.senderName')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right gray">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <v-select v-model="filterModel.processingById"
                                          :items="processingBy"
                                          @change="search"
                                          item-text="employeeName"
                                          item-value="employeeId"
                                          :label="$t('employeeStatistics.processingBy')"
                                          solo attach>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="input-group mb-3">
                                <v-select v-model="filterModel.requestType"
                                          :items="requestOption"
                                          item-text="name"
                                          item-value="id"
                                          @change="search"
                                          :label="$t('employeeStatistics.requestType')"
                                          solo attach>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="input-group mb-3">
                                <v-menu v-model="processingDateFromMenu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" lazy full-width min-width="290px" offset-y attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left" v-model="filterModel.dateFrom"
                                                :placeholder="$t('employeeStatistics.processingDateFrom')" readonly
                                                ref="processingDateFromPicker" v-on="on" type="text" />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.dateFrom" no-title scrollable @input="onDateChange('from')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                        <div class="col-md-4 mb-4">
                            <div class="input-group mb-3">
                                <v-menu v-model="processingDateToMenu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" lazy full-width min-width="290px" offset-y attach>
                                    <template v-slot:activator="{ on }">
                                        <div class="input-group">
                                            <input class="form-control border-right-0 border-left" v-model="filterModel.dateTo"
                                                :placeholder="$t('employeeStatistics.processingDateTo')" readonly ref="processingDateToPicker"
                                                v-on="on" type="text" />
                                            <div class="input-group-prepend">
                                                <span class="input-group-text right gray">
                                                    <i class="far fa-calendar-alt"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <v-date-picker v-model="filterModel.dateTo" no-title scrollable @input="onDateChange('to')">
                                    </v-date-picker>
                                </v-menu>
                            </div>
                        </div>
                    </div>
                    <template>
                        <v-data-table :headers="headers"
                                      :items="senderRequestHistoryModel"
                                      :total-items="sendersCount"
                                      :pagination.sync="pagination"
                                      @update:pagination="updatePaginate"
                                      :rows-per-page-text="$t('shared.rowsPerPage')"
                                      :rows-per-page-items='[10, 25, 50, 100]'
                                      item-key="requestId"
                                      class="elevation-1 table-striped">
                            <template v-slot:items="props">
                                <tr>
                                    <td class="text-center">
                                        {{ props.item.displayId }}
                                    </td>
                                    <td class="text-center">
                                        {{props.item.senderName}}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.clientName }}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.providerName }}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.processingDate }}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.processingResult }}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.requestType }}
                                    </td>
                                    <td class="text-center">
                                        {{ props.item.processingBy }}
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </template>
                </div>
            </div>
        </div>
    </div>
</div>